// TODO: roles should be gotten from API
export const roles = [
  {
    value: 'basic',
    label: 'Basic',
  },
  {
    value: 'admin',
    label: 'Admin',
  },
  {
    value: 'no-access',
    label: 'No Access',
  },
];
